import React from "react";

import LogoImg from "./logo.svg";

function Logo() {
  return <img src={LogoImg} alt="logo" />;
}

export default Logo;
